module.exports = __webpack_public_path__ + "static/media/Reshiram_gaussian2.dc293bc3.png";